import React from 'react';

export default function Header() {
  return (
    <header className="app-header">
      <div className="header-inner">
        <div className="header-brand">
          <img className="header-logo-img" src="/clementine-logo-mark.svg" alt="Clementine ABA" />
          <div>
            <div className="header-title">Clementine ABA</div>
            <div className="header-subtitle">HIPAA Compliance Training</div>
          </div>
        </div>
        <div className="header-badge">Powered by Odyssey Solutions</div>
      </div>
    </header>
  );
}
